/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAuthPermissionFromJSON, ApiAuthPermissionToJSON, } from './ApiAuthPermission';
export function ApiSimpleTenantPermissionFromJSON(json) {
    return ApiSimpleTenantPermissionFromJSONTyped(json, false);
}
export function ApiSimpleTenantPermissionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'group': !exists(json, 'group') ? undefined : json['group'],
        'permissions': !exists(json, 'permissions') ? undefined : (json['permissions'].map(ApiAuthPermissionFromJSON)),
    };
}
export function ApiSimpleTenantPermissionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'group': value.group,
        'permissions': value.permissions === undefined ? undefined : (value.permissions.map(ApiAuthPermissionToJSON)),
    };
}
